import { FIREBASE } from './firebase/firebaseConstants';
export function getProvider() {
  return FIREBASE;
}
